var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoutine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2016_199",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 12,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4031 0L18.0004 5.07543L17.7718 12.2525L17.5976 17.6948L14.1728 19.4628L12.7594 20.193L9.95607 21.6398L6.65234 17.9914L10.8679 15.8156L12.9324 14.7494L13.0485 11.1368L13.4031 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2016_199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.881 -5.64739L-4.11719 9.76025L11.7692 27.2867L28.7675 11.879L12.881 -5.64739Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2016_199",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 12,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5973 24.1798L0 19.1044L0.228567 11.9274L0.354588 7.96759L0.402772 6.48376L3.82758 4.71575L5.24099 3.98681L8.04434 2.54004L11.3481 6.18724L7.13254 8.36419L5.06802 9.42919L4.95188 13.043L4.5973 24.1798Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2016_199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.23065 -3.10686L-10.7676 12.3008L5.11966 29.8281L22.1179 14.4205L6.23065 -3.10686Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutine);
export default __webpack_public_path__ + "static/media/routine.2094276e8db36684461f3e4093a14deb.svg";
export { ForwardRef as ReactComponent };